module.exports = __webpack_public_path__ + "img/circle-lines-right.56b84af0.svg";